import $ from 'jquery';
import 'jquery.easing';
import timing from "DesignSystem/motion/timing";
import easingJs from "DesignSystem/motion/easing-js";

/**
 * @function messagesBehavior
 * @description Manage display of messages according session storage
 *
 */

export const messagesBehavior = (elt: any, cssClass: string, time?: number): any => {

    // Get id of message
    const id = elt.getAttribute('data-id-message');
    const sessionName = 'message';

    // If there's already a session
    if (id !== null && sessionStorage.getItem(sessionName) === id) {
        $(elt).hide();
        return true;
    }

    // Create close button
    const closeBtn = document.createElement('span');
    closeBtn.classList.add(`${cssClass}-close`);

    // Add close on message box
    elt.appendChild(closeBtn);

    // Behavior on click
    closeBtn.addEventListener('click', () => {
        $(elt).fadeOut({
            duration: time == null ? timing.params.std : time,
            easing: easingJs.params.standard,
        });

        // Get id for saving session
        if (id != null && sessionStorage.getItem(sessionName) !== id) {
            // @todo on Drupal context check if LocalStorage would be better or not
            sessionStorage.setItem(sessionName, id);
        }
    });
};
